import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { NEVER, Observable } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AppSyncService } from '../core/appsync.service';
import { PatientResponse } from './patient-portal-models/patient-portal.model';
import { PATIENT_PORTAL_API } from './patient-portal-schema';

@Injectable({
  providedIn: 'root'
})
export class PatientPortalService {


  public setPatientPortalId: any;
  public patientData: any;


  public patientInformation: PatientResponse;
  public amxDateConif: {
    startDate: string,
    expiresIn: string
  }
  public _savedPdfLink: string;
  constructor(private http: HttpClient, private appSyncService: AppSyncService

  ) { }

  public authenticatePatient(data): Observable<any> {
    const api = (environment.production) ? PATIENT_PORTAL_API.PROD : PATIENT_PORTAL_API.DEV;
    return this.http.post<any>(api, JSON.stringify(data));
  }

  public getPatientAssessmentBase64(url: string): Observable<Blob> {
    return this.http.get(url, { responseType: 'blob' }).pipe(catchError(e => {

      console.log(e);
      return NEVER;
    }));
  }



  public checkPortalVerification(id: string): Observable<any> {
    return this.appSyncService.hydrated().pipe(
      switchMap(patientPortal =>
        patientPortal.query({
          query: gql(this.getPatientPortalQuery()),
          variables: { id: id }
        })
      )
    )
  }


  private getPatientPortalQuery() {
    return `query GetPatientPortalGrant($id: ID!) {
    getPatientPortalGrant(id:$id) {
      id
    }
  }`
  }
  public convertToDate(date: string): Date {
    if (typeof date !== 'string') return null;
    //YYYYMMDDT HH MM SS Z Need to be converted into ISO 8601 Date & Time (UTC)
    const year: number = +date.slice(0, 4);
    const month: number = +date.slice(4, 6) - 1;
    const day: number = +date.slice(6, 8);
    const hour: number = +date.slice(9, 11);
    const minute: number = +date.slice(11, 13);
    const second: number = +date.slice(13, 15);

    return new Date(Date.UTC(year, month, day, hour, minute, second))

  }

  public parseUrlDate() {
    const amzUrl = new URL(this._savedPdfLink);
    const params = amzUrl.searchParams;
    const date = params.get('X-Amz-Date');
    const expires = params.get('X-Amz-Expires');
    const amzDate = this.convertToDate(date);
    return { amzDate, expires };
  }
}
